exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_gettingStated_PPzE4ncJST15aM_6BuhwF {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_video_1c59HuL9DfT4WX_5a8U20U {\n  position: relative;\n  float: left;\n  width: 300px;\n  height: 169px;\n  margin-right: 20px;\n  margin-bottom: 20px;\n}", ""]);

// Exports
exports.locals = {
	"IA_gettingStated": "IA_gettingStated_PPzE4ncJST15aM_6BuhwF",
	"IA_video": "IA_video_1c59HuL9DfT4WX_5a8U20U"
};